import classnames from 'classnames'
import { ComponentChild, FunctionalComponent, h } from 'preact'
import type { Spacing } from '../designSystem'

export interface ListGroupProps {
  spacing?: Spacing
  className?: string
  gutterBottom?: boolean
  children: ComponentChild[]
}

const ListGroup: FunctionalComponent<ListGroupProps> = (props) => {
  const { spacing = 4, gutterBottom, children, className, ...restProps } = props
  return (
    <ul
      className={classnames(
        className,
        'list-group',
        `list-group--spacing${spacing}`,
        {
          'list-group--gutter-bottom': gutterBottom
        }
      )}
      {...restProps}
    >
      {/** Note:
       * Use childToArray or React.Children
       * when migrate to React or Preact X
       * */}
      {props.children.map((child, index) => (
        <li key={index}>{child}</li>
      ))}
    </ul>
  )
}

export default ListGroup
